export default {
  name: 'marking--actionType',
};